import './index.scss';
import * as React from 'react';
import {Context} from '../../../../context/dataStore';
import Table from '../../../../components/Table/DegreeOfferrings/index';
import MajorSelectedSearch from './MajorSelectedSearch/MajorSelectedSearch';
import {Pagination} from '../../../../components';
import Dropdown from '../../../../components/Dropdown/Dropdown';
import '../../../../components/Dropdown/Dropdown.scss';
import {numPerPageOptions} from '../constants';
import {mapToTotalMajors, degreesSum, lastUpdateFromModule} from '../util';
import {getModuleStatusStr} from '../../../../utils/utils';
import TotalUtils from '../../../../utils/TotalUtil';

// eslint-disable-next-line react/prop-types
const MajorSelected = ({stateProps, selectarray, setSelectedArray, readOnly}) => {
  const {getMajors, dispatch} = React.useContext(Context);
  const [dynamicData, setDynamicData] = React.useState([]);
  const [searchData, setSearchData] = React.useState([]);
  const [selectInput, setSelectInput] = React.useState(numPerPageOptions[0]);
  const [addnewmajor, setFlagfornewMajor] = React.useState(false);

  const [currentPage, setCurrentPage] = React.useState(1);
  const [recordPerPage, setRecordPerPage] = React.useState(numPerPageOptions[0]);
  const lastPage = Math.ceil(dynamicData?.length / recordPerPage);
  const displayData = dynamicData?.slice((currentPage - 1) * recordPerPage, currentPage * recordPerPage);

  const {org_id, setModifiedOn} = stateProps;

  React.useEffect(() => {
    const Util = new TotalUtils();
    let isCurrent = true;
    const fetchData = async () => {
      const res = await getMajors(parseInt(org_id));

      const toMap = mapToTotalMajors(res);
      const temp = [];
      toMap.forEach(obj => {
        Object.values(obj)[0].forEach(major => {
          major.boxChecked = true;
          major.new = false;
          major.modified = false;
          temp.push(major);
        });
      });
      setSelectedArray([...Util.elegantRemoveDuplicate(temp)]);

      if(temp.length > 0) {
        dispatch({type: 'SELECT_ALL_COLUMNS', payload: degreesSum(temp)});
      }else{
        dispatch({type: 'SELECT_ALL_COLUMNS', payload:[false, null, null, null, null, null, null, null, null]});
      }
      //calculate most updated date from each module
      if(res) {
        setModifiedOn(getModuleStatusStr('Modified', lastUpdateFromModule(res)));
      }
    }
    if(isCurrent) {
      fetchData();
    }
    return() =>isCurrent = false;
  }, [dispatch, getMajors, org_id, setModifiedOn, setSelectedArray]);

  React.useEffect(() => {
    const Util = new TotalUtils();
    if (selectarray) {
      setDynamicData(Util.onlyTrueObjects(selectarray));
      setSearchData(Util.onlyTrueObjects(selectarray));
    }
  }, [selectarray]);

  React.useLayoutEffect(()=>{
    if(addnewmajor) {
      document.getElementById("container-degreeofferred_h2").scrollIntoView({
        behavior: "smooth"
      });
    }
    return()=>setFlagfornewMajor(false);
  }, [addnewmajor]);

  const actionDataSentBack = filterData => setDynamicData(filterData);

  const handleOnChange = el => {
    switch (el) {
      case 'pre': {
        const newpage = currentPage === 1 ? currentPage : currentPage - 1;
        setCurrentPage(() => newpage);
        document.getElementById('selectedMajorInput').setAttribute('aria-describedby', `selectedMajor-page-${newpage}`);
        break;
      }
      case 'next': {
        const newpage = currentPage === lastPage ? currentPage : currentPage + 1;
        setCurrentPage(() => newpage);
        document.getElementById('selectedMajorInput').setAttribute('aria-describedby', `selectedMajor-page-${newpage}`);
        break;
      }
      default: {
        setCurrentPage(() => el);
        document.getElementById('selectedMajorInput').setAttribute('aria-describedby', `selectedMajor-page-${el}`);
      }
    }
  };

  return (
    <div className="majorSelectedContainer">
      <div className="majorSelectedContainer-toplevelrow1">
        <span style={{width: "100%"}} role='heading' aria-level='3' id='selectedmajors'>Selected Majors</span>
        <div className="majorSelectedContainer-toplevelrow1-inner">
          <MajorSelectedSearch searchData={searchData} actionDataSentBack={actionDataSentBack} setPage={setCurrentPage} />
          <button style={{width: "200px"}} onClick={()=>setFlagfornewMajor(true)} id="majorSelectedContainer-addnewmajorbtn" type="button" className="cb-btn cb-btn-primary">+ Add New Major</button>
        </div>
      </div>
      <hr className='horizontalLine' />
      
      <Table stateProps={stateProps} displayarray={displayData} readOnly={readOnly} actionDataSentBack={actionDataSentBack} allData={selectarray} setSelectedArray={setSelectedArray} />
      <div style={{display: `${dynamicData.length === 0 ? 'none' : 'flex'}`, alignItems: `center`, justifyContent: 'center'}}>

        <div className='item' id='selectShowDD'>
          <Dropdown
            selectData={[...numPerPageOptions]}
            selectValue={selectInput}
            halfInput={false}
            selectLabel={'Rows per page'}
            selectId={'rowPerPageSelect'}
            onChangeSelectValue={val => {
              // eslint-disable-next-line no-unused-expressions
              setSelectInput(val), setRecordPerPage(parseInt(val)), setCurrentPage(1);
            }}
          />
        </div>

        <div className='item'>
          <Pagination currentPage={currentPage} lastPage={lastPage} onPageChange={handleOnChange} id='selectedMajor' />
        </div>
      </div>
    </div>
  );
};

export default MajorSelected;